export const translationEngDefault = {
  SkhemataBlogSearch: {
    searchPlaceholder: 'Enter Search Keyword...',
  }
};
